/**
 * Flow Studio's call settings for the shared NodeTemplateApiClient.
 *
 * The shared client defaults to a single 5-minute attempt. Flow Studio opts in so the designer does
 * not hang on a stalled request. 2 attempts x 30 s means the worst case is about 60 s before the
 * designer gives up. This is a deliberate tradeoff against failing a slow but healthy tenant's
 * by-type query.
 *
 * Kept in its own module, with no store imports, so tests can load it without the whole store.
 */
import { apiConfig } from '@flow-studio/api';
import type { NodeTemplateApiClientOptions } from '../../../../NodeTemplates/ApiClient/NodeTemplateApiClient';

export const NODE_TEMPLATE_CLIENT_OPTIONS: NodeTemplateApiClientOptions & { baseUrl: string } = {
  baseUrl: apiConfig.baseUrl,
  timeoutMs: 30000,
  maxAttempts: 2,
};
